module.exports = __webpack_public_path__ + "img/icon_4_49.626b24f2.png";